import {
  LabelList,
  Pie,
  PieChart,
  ResponsiveContainer,
  Tooltip,
} from "recharts";
import { randomColorPicker } from "../../../../../../../../../../utils/randomColorPicker";
import { VisualizationData } from "../../../types";

type Props = {
  chart: VisualizationData;
};

const CustomPieChart = ({ chart }: Props) => {
  return (
    <ResponsiveContainer width="100%" height={250}>
      <PieChart>
        <Pie
          data={chart.data.map((d: any) => ({
            ...d,
            [chart.y_axis_name]: parseFloat(d[chart.y_axis_name]),
          }))}
          dataKey={chart.y_axis_name}
          nameKey={chart.x_axis_name}
          label={({ name }) => name}
          fill={randomColorPicker()}
        >
          <LabelList dataKey={chart.y_axis_name} position="top" />
        </Pie>
        <Tooltip />
      </PieChart>
    </ResponsiveContainer>
  );
};

export default CustomPieChart;
